<template>
    <ul>
		<li v-for="p in providers" :key="p.provider">
            <router-link to="/" v-bind:class="{
				inactive: p.provider != currentProvider
			}" @click.native="setCurrentProvider(p.provider)">
				{{ p.name }}
			</router-link>
        </li>
    </ul>
</template>

<script>
import SidebarList from '.'

export default {
	name: 'sidebar-provider-list',
	extends: SidebarList
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
